<div class="modal-content">
  <div class="modal-header">
    <h4 class="modal-title"><i class="fas fa-window-restore"></i> {{title | translate}}</h4>
  </div>
  <div class="modal-body">
    <div class="row" [hidden]="verified">
      <div class="col-md-1">
        <i class="fa fa-question-circle text-warning fa-2x"></i>
      </div>
      <div class="col-md-11">
        <div [innerHTML]="'QUESTION.DO-YOU-WANT-CHECK-IF-HAVE-SIGNATURE-COMPONENT-INSTALLED' | translate"></div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12" [hidden]="!verified">
        <div [innerHTML]="description | translate"></div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <div *ngIf="!verified">
      <button type="button" class="btn btn-outline-success" (click)="accept()">
        <i class="fas fa-check"></i> {{ "BUTTON.VERIFY" | translate }}
      </button>
    </div>
    <div *ngIf="verified && showDownloadButton && isNotMacOs()">
      <button type="button" class="btn btn-dark" (click)="download()">
        <i class="fas fa-download"></i> {{ "BUTTON.DOWNLOAD" | translate }}
      </button>
    </div>
    <button type="button" class="btn btn-outline-danger"
            (click)="cancel()">
      <i class="fas fa-times-circle"></i> {{verified ? ('BUTTON.CLOSE' | translate) : ('BUTTON.CANCEL' | translate)}}</button>
  </div>
</div>
<app-loading *ngIf="loading"></app-loading>
